import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import ServiceDog from "@/pages/ServiceDog";
import Programs from "@/pages/Programs";
import Impact from "@/pages/Impact";
import GetInvolved from "@/pages/GetInvolved";
import About from "@/pages/About";
import News from "@/pages/News";
import NewsArticle from "@/pages/NewsArticle";
import ReminderCancel from "@/pages/ReminderCancel";
import Privacy from "@/pages/Privacy";
import Accessibility from "@/pages/Accessibility";
import NotFound from "@/pages/NotFound";
import Staff from "@/pages/Staff";
import StaffReset from "@/pages/StaffReset";

const Layout = () => (
  <>
    <SmoothScroll />
    <Header />
    <main id="main" tabIndex={-1} className="outline-none">
      <Outlet />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/service-dog-program" element={<ServiceDog />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/about" element={<About />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/reminder-cancel" element={<ReminderCancel />} />
          <Route path="/news/:slug" element={<NewsArticle />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/staff/reset" element={<StaffReset />} />
          <Route path="/staff/export" element={<Navigate to="/staff" replace />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
